module.exports = __webpack_public_path__ + "725dab38260aad85a14fb24c2e7b3734.svg";